import { META } from './data';

export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1A1410] text-[#F4EEE0] mt-24">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.6fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-5xl text-[#F4EEE0]">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#C9A06A] mt-2">— The Open Letter —</p>
          <p className="font-serif text-sm text-[#F4EEE0]/55 mt-5 leading-[1.7] max-w-md">A monthly correspondence for executives. Written by Mira Vance from a desk in Brooklyn and another in Berlin. Published since {META.est}.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#C9A06A] mb-3">Sections</p>
          <ul className="space-y-2 font-serif text-sm text-[#F4EEE0]/85">
            <li><button onClick={() => setPage('notes')} className="hover:text-[#C9A06A]">§ II · Field Notes</button></li>
            <li><button onClick={() => setPage('engagements')} className="hover:text-[#C9A06A]">§ III · Engagements</button></li>
            <li><button onClick={() => setPage('apply')} className="hover:text-[#C9A06A]">§ IV · Correspondence</button></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#C9A06A] mb-3">Subscribe by post</p>
          <p className="font-serif text-sm text-[#F4EEE0]/85 leading-[1.7]">Letters arrive once a month, on the second Friday. No advertising, no sponsorship, no archive paywall.</p>
          <div className="flex border-b border-[#F4EEE0]/30 mt-4">
            <input data-testid="mv-footer-email" placeholder="your.address@…" className="bg-transparent text-[#F4EEE0] py-2 outline-none font-serif text-sm flex-1 placeholder:text-[#F4EEE0]/35" />
            <button data-testid="mv-footer-subscribe" className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9A06A] px-3 hover:text-[#F4EEE0]">Send →</button>
          </div>
        </div>
      </div>
      <div className="border-t border-[#F4EEE0]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F4EEE0]/40">
        <span>© 2026 {META.brand} · The Open Letter · No advertising, no archive paywall</span>
        <span>Set in Caslon & Söhne Mono · Brooklyn / Berlin</span>
      </div>
    </footer>
  );
}
